import type { WizardStepId as WizardStepIdType } from '@onboarding/domain/types';

export const WIZARD_STEPS = {
  RESTAURANT_TYPE: 'RESTAURANT_TYPE',
  TABLE_SERVICE: 'TABLE_SERVICE',
  TAX: 'TAX',
  CASH_REGISTER: 'CASH_REGISTER',
  TIP: 'TIP',
  RECEIPT: 'RECEIPT',
} as const;

export type WizardStepKey = Readonly<typeof WIZARD_STEPS[keyof typeof WIZARD_STEPS]>;

/**
 * Canonical ordered sequence of wizard steps.
 * Single source of truth for step positioning and navigation — both the wizard
 * navigation and the completion summary "edit" buttons derive their indices from here.
 */
export const WIZARD_STEP_ORDER = [
  WIZARD_STEPS.RESTAURANT_TYPE,
  WIZARD_STEPS.TABLE_SERVICE,
  WIZARD_STEPS.CASH_REGISTER,
  WIZARD_STEPS.TIP,
  WIZARD_STEPS.TAX,
  WIZARD_STEPS.RECEIPT,
] as const;

const VALID_STEP_IDS = new Set<string>(Object.values(WIZARD_STEPS));

/**
 * Creates a validated WizardStepId value object.
 *
 * @param raw - Raw step identifier string
 * @returns Validated WizardStepId
 * @throws Error if step ID is not a recognized wizard step
 */
export const createWizardStepId = (raw: string): WizardStepIdType => {
  if (!VALID_STEP_IDS.has(raw)) {
    throw new Error(`Invalid wizard step ID: ${raw}. Must be one of: ${[...VALID_STEP_IDS].join(', ')}`);
  }
  return raw as WizardStepIdType;
};
